import { Component, computed, input, linkedSignal, output, ViewEncapsulation } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { canAddQuantity, getEffectiveMaxQuantity } from '@cakeiteasy/web-utils';

import { CakeItemVariant } from '../cake-item-variant';

/** Card of a pieces product with one variant: a quantity counter (or "Order now") on hover, always shown on touch. */
@Component({
  standalone: true,
  selector: 'cake-item-pieces',
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, NgTemplateOutlet, RouterLink, TranslateModule, CakeItEasyWebUiModule],
  templateUrl: './cake-item-pieces.component.html',
})
export class CakeItemPiecesComponent extends CakeItemVariant {
  cartCount = input(0);

  /** builder link / "order now": opens the product */
  open = output<void>();
  /** mobile "Buy": adds the minimum quantity */
  buy = output<void>();
  countChange = output<number>();

  itemCount = linkedSignal(() => this.cartCount());

  maxCount = computed(() => getEffectiveMaxQuantity(this.cake()));
  canHasAddOns = computed(() => this.cake().canHasMotive || this.cake().canHasExtraProducts);

  isCounterPlusDisabled = computed(() => {
    const cake = this.cake();
    const currentCount = this.cartCount() || 0;
    // an empty cart adds the minimum quantity, otherwise one increment step
    const quantityToAdd = currentCount ? (cake.increment || 1) : cake.minQuantity;

    return !canAddQuantity(cake, currentCount, quantityToAdd);
  });

  onBuy() {
    this.itemCount.set(this.cake().minQuantity);
    this.buy.emit();
  }

  updateCount(count: number) {
    this.itemCount.set(count);
    this.countChange.emit(count);
  }
}
